import { Typography } from 'antd';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Avatar } from 'components/atoms/avatar';

const { Text } = Typography;

interface AvatarDetailsProps {
  link?: string;
  src?: string;
  title?: string;
  size?: 'regular' | 'large';
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Details = styled.div<Pick<AvatarDetailsProps, 'size'>>`
  color: var(--gray-100);
  margin-left: ${({ size }) =>
    `${size === 'large' ? 'var(--spacing-06)' : 'var(--spacing-04)'}`};
`;

const LinkWrapper = styled(Link)`
  color: inherit;

  &:hover {
    text-decoration: underline;
  }
`;

export const AvatarWithDetails: FC<AvatarDetailsProps> = ({
  link,
  src,
  title = '-',
  size = 'regular',
}) => (
  <Wrapper>
    <Avatar name={title} src={src} />
    <Details size={size}>
      {link ? (
        <LinkWrapper to={link}>{title}</LinkWrapper>
      ) : (
        <Text
          ellipsis={{
            tooltip: title,
          }}
        >
          {title}
        </Text>
      )}
    </Details>
  </Wrapper>
);
